import Board from "./Board";

function Breakout() {
  return (
    <div>
      <Board />
    </div>
  );
}

export default Breakout;
